import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DataTubeIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#e45785' : this.getColor()
    return [
      <g>
        <path fill={ color }
              d="M47.62,18a11.84,11.84,0,0,0-7.16-4.54,13.74,13.74,0,0,0-26.84-2.67,13.55,13.55,0,0,0-1.43-.08A12.14,12.14,0,0,0,11.42,35v0h28a10.38,10.38,0,0,0,8.23-17Z"/>
        <path fill={ '#fff' } d="M37.22,30.63a1,1,0,0,1-.7-.29l-4.86-4.86a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l4.86,4.86a1,1,0,0,1-.71,1.71Z"/>
        <path fill={ '#fff' }
              d="M33,16.81a.25.25,0,0,0,0-.08v-.12a8.18,8.18,0,0,0-.29-1.77h0c-.07-.24-.14-.47-.23-.7a1.54,1.54,0,0,0-.08-.19l0-.08a7.9,7.9,0,0,0-3.1-3.64A8.56,8.56,0,0,0,28,9.59a2.19,2.19,0,0,1,0,.81,2,2,0,0,1-.6,1.14,5.12,5.12,0,0,1,.73.39,5.91,5.91,0,0,1,2.24,2.54h0a1.42,1.42,0,0,1,.08.18l0,.07.06.14a5.41,5.41,0,0,1,.24.81,6.32,6.32,0,0,1,.15,1v.34a5,5,0,0,1-.07.86,6,6,0,0,1-1.82,3.45V17a1,1,0,0,0-2,0v5.66a5.92,5.92,0,0,1-1,.28,1.64,1.64,0,0,0,0-.22V18.57a1,1,0,1,0-2,0v4.11a1.09,1.09,0,0,0,0,.25h0a6.63,6.63,0,0,1-1-.24V20.77a1,1,0,1,0-2,0v.76a5.78,5.78,0,0,1-.92-1,6,6,0,0,1,5.76-9.46,1,1,0,0,0,1.15-.84,1,1,0,0,0-.84-1.14,8,8,0,1,0-2.46,15.8A7.53,7.53,0,0,0,25,25a8,8,0,0,0,7.88-6.77,5.86,5.86,0,0,0,.09-1h0v-.4Z"/>
      </g>
    ]
  }
  getViewBox = () => '0 0 50 30'
}
